<template>
  <TrainerLayout>
    <div class="container mx-auto px-4">
      <UpcomingSessionsCard :data="trainerSessionList" :routerLink="false" />
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import UpcomingSessionsCard from "@/components/UpcomingSessionsCard";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UpcomingSessions",
  components: {
    TrainerLayout,
    UpcomingSessionsCard,
  },
  computed: {
    ...mapGetters(["trainerSessionList"]),
  },
  methods: {
    ...mapActions(["getTrainerSessionList"]),
  },
  async created() {
    await this.getTrainerSessionList({});
  },
};
</script>